/**
 * issue #154: Drive に保存済みの結果を fileName で記録する永続フラグ。
 * 保存済みという「事実」だけを持ち、 webViewLink / fileId は永続化しない
 * (共有 URL は陳腐化しうるので都度 Drive から取得する。 DriveLinkCopyButton 参照)。
 */
export const DRIVE_SAVED_KEY = 'omakase-unshi:drive-saved';

/** 保持する保存済み結果の上限。 超過分は古いものから捨てる (localStorage の肥大化防止)。 */
const MAX_ENTRIES = 50;

function readEntries(): string[] {
  if (typeof window === 'undefined') return [];
  const raw = window.localStorage.getItem(DRIVE_SAVED_KEY);
  if (!raw) return [];
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((v): v is string => typeof v === 'string');
  } catch {
    // 壊れた値は未保存扱い (次の markDriveSaved で上書き復旧される)。
    return [];
  }
}

function writeEntries(entries: string[]): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(DRIVE_SAVED_KEY, JSON.stringify(entries.slice(-MAX_ENTRIES)));
}

/** 結果 (PDF の fileName で同定) を Drive 保存済みとして記録する。 冪等。 */
export function markDriveSaved(fileName: string): void {
  if (!fileName) return;
  const entries = readEntries();
  if (entries.includes(fileName)) return;
  writeEntries([...entries, fileName]);
}

/** 結果が Drive 保存済みか。 */
export function isDriveSaved(fileName: string): boolean {
  if (!fileName) return false;
  return readEntries().includes(fileName);
}

/**
 * 保存済みフラグを落とす。 再生成 / 新規投入 (中身が変わる) や、
 * Drive 上に見つからない (ユーザーが削除/移動した) と分かった時に呼ぶ。
 */
export function clearDriveSaved(fileName: string): void {
  if (!fileName) return;
  const entries = readEntries();
  if (!entries.includes(fileName)) return;
  writeEntries(entries.filter((name) => name !== fileName));
}
